<template>
    <div class="flujo-produccion">
        <h3 class="mb-4">
            <font-awesome-icon icon="fa-industry" class="me-2" />
            Flujo de Producción
        </h3>

        <!-- Paso a paso visual -->
        <div class="steps-container sticky-top">
            <div v-for="(seccion, index) in secciones" :key="seccion.nombre" class="step"
                :class="{ active: currentSection === seccion.nombre }" @click="currentSection = seccion.nombre">
                <font-awesome-icon :icon="seccion.icono" class="me-2" />
                {{ index + 1 }}. {{ seccion.label }}
                <font-awesome-icon icon="fa-arrow-right" class="ms-2 step-arrow" />
            </div>
        </div>



        <!-- Componente activo -->
        <component :is="currentComponent" :club_id="clubActual.id" @refrescar="refrescarTodo" />
    </div>
</template>



<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Importación de vistas
import BiomasaEnEsperaComponent from '@/components/Biomasa/ListaMateriaPrimaWrapper.vue';
import MateriaPrimaView from '@/views/MateriaPrima/GestionarMateriaPrima.vue';
import ProductoFinalView from '@/views/ProductoFinal/GestionarProductoFinal.vue';
import ProductoEnvasadoView from '@/views/ProductoFinal/GestionarProductoFinalEnvasado.vue';

export default {
    name: 'FlujoProduccion',
    components: {
        FontAwesomeIcon,
        BiomasaEnEsperaComponent,
        MateriaPrimaView,
        ProductoFinalView,
        ProductoEnvasadoView
    },
    data() {
        return {
            clubActual: this.$store.getters.getClubActual,
            currentSection: 'biomasa',
            secciones: [
                { nombre: 'biomasa', label: 'Biomasa', icono: ['fas', 'seedling'], color: '#28a745' },
                { nombre: 'materia_prima', label: 'Materia Prima', icono: ['fas', 'flask'], color: '#a84e1a' },
                { nombre: 'producto_final', label: 'Producto Final Bulk', icono: ['fas', 'vial'], color: '#205375' },
                { nombre: 'producto_envasado', label: 'Producto Envasado', icono: ['fas', 'box'], color: '#5a5a89' }
            ]
        };
    },
    computed: {
        currentComponent() {
            switch (this.currentSection) {
                case 'biomasa':
                    return 'BiomasaEnEsperaComponent';
                case 'materia_prima':
                    return 'MateriaPrimaView';
                case 'producto_final':
                    return 'ProductoFinalView';
                case 'producto_envasado':
                    return 'ProductoEnvasadoView';
                default:
                    return 'BiomasaEnEsperaComponent';
            }
        }
    },
    mounted() {
        this.setColorVariables();
    },
    watch: {
        currentSection() {
            this.setColorVariables();
            this.scrollToTop();
        }
    },
    methods: {
        refrescarTodo() {
            // Hook opcional para notificar recargas
        },
        setColorVariables() {
            const seccion = this.secciones.find(s => s.nombre === this.currentSection);
            if (seccion) {
                document.documentElement.style.setProperty('--color-activo', seccion.color);
            }
        },
        scrollToTop() {
            const el = this.$el;
            if (el && el.scrollIntoView) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }

    }
};
</script>




<style scoped>
.sticky-top {
    position: sticky;
    top: 70px;
    /* Ajustar según tu navbar */
    z-index: 1000;
    background-color: #f8f9fb;
    /* color de fondo para evitar traslucir */
    padding-top: 8px;
    padding-bottom: 8px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
    margin-bottom: 16px;
}


.steps-container {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    align-items: stretch;
    margin-bottom: 24px;
}

.step {
    cursor: pointer;
    flex: 1;
    min-width: 180px;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: #f0f0f0;
    color: #777;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    font-weight: 500;
    transition: all 0.2s ease;
    position: relative;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.step.active {
    border-color: var(--color-activo);
    background-color: rgba(255, 255, 255, 0.95);
    color: var(--color-activo);
    font-weight: 600;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
}

.step .step-arrow {
    margin-left: auto;
    color: #bbb;
    font-size: 0.85rem;
    transition: opacity 0.2s ease;
}

.step:last-child .step-arrow {
    display: none;
}

.step:hover {
    background-color: #e9e9e9;
}

@media (max-width: 600px) {
    .step {
        font-size: 0.9rem;
        padding: 10px 12px;
    }
}

.steps-container::-webkit-scrollbar {
    height: 6px;
}

.steps-container::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}
</style>
